import axios from 'axios';
import { baseUrl } from '../utils/constants';

export const emailManager = async (payload) => axios.post(
    `${baseUrl()}submissions/emailReferral/`, payload, { withCredentials: true },
);

export const productionManagerReferral = async (payload) => axios.post(
    `${baseUrl()}submissions/productionManagerReferral/`, payload, { withCredentials: true },
);

